import { useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import userimg from "../../assets/images/avatar.svg";
import star from "../../assets/images/star.svg";
import { Button, Col, Row } from "react-bootstrap";
import editbtn from "../../assets/images/edit.svg";
import msgimg from "../../assets/images/msg.svg";
import { jobService } from "services/job.service";
import { Link, useNavigate } from "react-router-dom";
import { cardBGColor, getFormattedDate } from "utils";
import BidList from "Dashboard/Dashboardpages/BidList";
import msgActiveimg from "../../assets/images/msg-blue.svg";
import useCurrentUser from "hooks/useCurrentUser";
import ViewModal from "components/Modals/ViewModal";
import { toast } from "react-toastify";
import { chatService } from "services/chat.service";
import { paymnetService } from "services/payment.service";
import SolarFiles from "components/Modals/Clientpanelpipup/SolarFiles";
import FolderDetail from "components/Modals/FolderDetail";
import { userService } from "services";

const ActivecadsClient = ({
  data,
  setData,
  setActiveTab,
  setShowBids,
  handleViewMore,
  activeTab
}) => {
  const [show, setShow] = useState(false);
  const [bid, setBid] = useState();
  const [jobId, setJobId] = useState('')
  const [bidShow, setBidShow] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [folderId, setFolderId] = useState('')
  const [clientPaymentData, setClientPaymentData] = useState('')
  const [paidData, setPaidData] = useState([]);
  const [selectedFolderId, setSelectedFolderId] = useState(false)
  const [viewFile, setViewFile] = useState(false)
  const [folderDetails, setFolderDetails] = useState({});

  const { user } = useCurrentUser();
  const navigate = useNavigate();

  const handleClose = () => {
    setShow(false);
    setViewFile(false);
    setBidShow(false);
  };

  const handleShow = (bid) => {
    setBid(bid);
    // setFolderId(folderId);
    setBidShow(true);
    setShow(true);
  }

  const markjobCompleted = async (jobId) => {
    setJobId(jobId)
    const payload = {
      "jobId": jobId
    }

    try {
      const response = await jobService.markCompleted(payload)
      toast.success(response?.data?.message)
      setActiveTab('Completed');
    }
    catch (err) {
      console.log(err)
    }
  }

  const getCardBg = (item) => {
    if (item?.totalBids > 0 && item?.status === "Completed") {
      return 'skybedge-bg';
    }
    if (item?.totalBids > 0 && item?.status === "Pending") {
      return 'skybedge-bg';
    }
    return `${cardBGColor[item?.status?.toLowerCase()]}-bg`;
  }

  const onChatClick = async (jobId, clientId, pilotId) => {
    try {
      const response = await chatService.startChat({ jobId, clientId, pilotId });
      navigate(`/chat?id=${response?.data?.data?._id}`)
    } catch (err) {
      toast.error(err.data.message);
    }
  }


  const handleDownLoad = async (id) => {
    try {
      const response = await jobService.DownloadReport(id);
      // Convert blob to download link
      const fileURL = window.URL.createObjectURL(response.data);
      // Extract filename from headers if available
      const disposition = response.headers["content-disposition"];
      let filename = "report.pdf";
      if (disposition && disposition.includes("filename=")) {
        filename = disposition
          .split("filename=")[1]
          .replace(/['"]/g, "")
          .trim();
      }

      // Create link element and trigger download
      const link = document.createElement("a");
      link.href = fileURL;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // free memory
      window.URL.revokeObjectURL(fileURL);
    } catch (err) {
      console.error("Download failed:", err);
    }
  };


  const handlePayNow = async (job) => {
    try {
      const response = await paymnetService.createCheckoutSession({ type: 'Job', id: job._id });
      response?.data?.data?.url && window.open(response?.data?.data?.url, '_blank');
    } catch (err) {
      toast.error(err.data.message);
    }
  }
  return (
    <>
      {
        data?.jobs?.length > 0 ? (
          <div style={{ marginTop: 20 }}>
            <Row>
              {data?.jobs?.map((item, i) => {
                return <>
                  <Col xl={4} lg={6}>
                    <div className={`job-card ${getCardBg(item)}`} style={{ minHeight: '350px' }}>
                      <div className="d-flex align-items-center gap-2">
                        {item?.status !== "Pending" && (
                          <>
                            {user?.roleType === 'CLIENT' ? (
                              <div className="d-flex justify-content-between align-items-center gap-2 mb-3">
                                <div className="d-flex align-items-center ">
                                  <img
                                    alt="avatar"
                                    src={`${user?.baseS3Url}${item?.pilotId?.avatar || ""}`}
                                    className="round-img border border-secondary"
                                    onError={(e) => {
                                      e.currentTarget.onerror = null; // avoid infinite loop
                                      e.currentTarget.src = userimg;  // fallback image
                                    }}
                                  />

                                  <p className="mb-0 dark-textss ms-2">{item?.pilotId?.fullName}</p>
                                </div>
                                <img alt="" src={msgActiveimg} className="msg-v" onClick={() => onChatClick(item?._id, item?.clientId, item?.pilotId?._id)} />
                              </div>
                            ) : (
                              <div className="d-flex justify-content-between align-items-center gap-2 mb-3">
                                <div className="d-flex align-items-center">
                                  <img alt="avatar" src={item?.clientId?.avatar ? `${user?.baseS3Url}${item?.clientId?.avatar}` : userimg} className="round-img border border-secondary" />
                                  <p className="mb-0 dark-textss ms-2">{item?.clientId?.fullName}</p>
                                </div>
                                <img alt="" src={msgActiveimg} className="msg-v" onClick={() => onChatClick(item?._id, item?.clientId?._id, item?.pilotId?._id)} />
                              </div>
                            )}
                          </>
                        )}
                        {user?.roleType === 'CLIENT' && item?.status === "Completed" && (
                          <>
                            <p className="">
                              <img src={star} alt="Rating" className="me-2" />{Math.round(item?.pilotId?.avgRating)} Rating
                            </p>
                          </>
                        )}
                      </div>
                      <div className="d-flex justify-content-between align-items-center gap-1 flex-wrap">
                        <h3 className="mt-0">
                          {item?.title}
                        </h3>
                        {item?.totalBids > 0 && item?.status === "Pending" ? <p className="mb-0 otp-bedge" onClick={() => handleShow(item?._id, item?.folderId)}>
                          {item?.totalBids} {item?.totalBids > 1 ? 'Bids' : 'Bid'}
                        </p> : <>{item?.status === "Pending" && <p className="pending-bedge mt-2">{item?.status}</p>}</>}
                        {item?.status !== "Completed" && item?.otp && <p className="mb-0 otp-bedge text-uppercase">
                          OTP {item?.otp}
                        </p>}

                      </div>
                      <small className="fw-bold">SK{item?.id}</small>
                      <br />
                      <Link to={`${item?._id}`}>
                        <p className="light-texts">Destination</p>
                        <address className="dark-textss line-clamp ">
                          {item?.address}
                        </address>
                        <div className="row">
                          <div className="col-lg-6">
                            <div>
                              <p className="light-texts">Required Date</p>
                              <p className="dark-textss">{getFormattedDate(item?.requiredDate)}</p>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <p className="light-texts">Area Size ({item?.areaUnit?.toLowerCase()})</p>
                            <p className="dark-textss">{item?.areaSize}</p>
                          </div>
                        </div>
                      </Link>
                      {item?.status === "PilotAssigned" &&
                        <>
                          <div className="d-flex justify-content-between align-items-center amount-div">
                            <h5 >Final Approved Amount($)</h5>
                            <p className="m-0">{item?.jobFinalCost}</p>
                          </div>
                          <div className="active-card mt-2 w-100">
                            {item?.paymentStatus === "Paid" || paidData.includes(item?._id) ? "Paid" : (
                              <Button onClick={() => handlePayNow(item)} className="w-100">Pay Now</Button>
                            )}
                          </div>
                        </>
                      }
                      {item?.status === 'Completed' && (
                        <div className="d-flex flex-wrap justify-content-between footer-btns gap-2">
                          {user?.roleType === 'CLIENT' ?
                            (<>
                              <button type="submit" className="btn white-btn" onClick={() => {
                                setSelectedFolderId(item?.folderId)
                                setShow(true)

                              }}> View Files</button>

                              <SolarFiles show={show} setShow={setShow} handleClose={handleClose} id={selectedFolderId}
                                setFolderDetails={setFolderDetails}
                                setShowDetailModal={setShowDetailModal}
                              />
                            </>) :
                            (<>
                              <button type="submit" className="btn white-btn" onClick={() => {
                                setViewFile(true)
                                setFolderId(item?.folderId)
                              }
                              }>
                                View Files
                              </button>
                            </>)
                          }
                          {showDetailModal && <FolderDetail show={showDetailModal} setShow={setShowDetailModal} folder={folderDetails} setFolder={setFolderDetails} />}

                          <button onClick={() => { handleDownLoad(item?._id) }} className="btn blue-btn" download >
                            Download Report
                          </button>
                        </div>
                      )}
                      {item?.status === 'WorkStarted' && user?.roleType === 'CLIENT' && (
                        <div className="d-flex flex-wrap gap-3 amount-div justify-content-between " >

                          <h5>Total Amount ($)</h5>
                          <p> &nbsp; {item?.jobFinalCost}</p>
                        </div>
                      )
                      }
                      {item?.status === 'WorkStarted' && user?.roleType === 'PILOT' && (
                        <>
                          {item?.folderId ?
                            (
                              <>
                                <div>
                                  <div className="d-flex flex-wrap gap-3 amount-div justify-content-between " >

                                    <h5>Total Amount ($)</h5>
                                    <p> &nbsp; {item?.jobFinalCost}</p>
                                  </div>
                                  <Link to={`/my-files/?jobId=${item?._id}`} className="btn white-btn w-100 d-block" >
                                    <div className="d-flex justify-content-between">
                                      Edit Files
                                      <img alt="" src={editbtn} />
                                    </div>
                                  </Link>
                                  <button onClick={() => markjobCompleted(item?._id)} className="btn blue-btn w-100 d-block mt-3">
                                    Mark as Completed
                                  </button>
                                </div>
                              </>
                            ) : (
                              <>
                                <div className="">
                                  <div className="d-flex flex-wrap gap-3 amount-div justify-content-between " >

                                    <h5>Total Amount ($)</h5>
                                    <p> &nbsp; {item?.jobFinalCost}</p>

                                  </div>
                                  <Link to={`/my-files/?jobId=${item?._id}`} className="btn white-btn add-btn  w-100 d-block">
                                    + Add Files
                                  </Link>
                                  <button className="btn blue-btn w-100 d-block mt-3 btn-disable">
                                    Mark as Completed
                                  </button>
                                </div>
                              </>
                            )}
                        </>
                      )
                      }
                    </div>
                  </Col>
                </>
              })}
            </Row >
            {data?.jobs?.length < data?.totalJobs && <div className="d-flex flex-wrap gap-2 justify-content-center">
              <button className=" blue-btnnn text-white" onClick={handleViewMore}>
                View More
              </button>
            </div>}
            <Offcanvas
              show={bidShow}
              onHide={handleClose}
              backdrop="static"
              placement="end"
              className="bid-request-modal-client"
            >
              <Offcanvas.Header closeButton></Offcanvas.Header>
              <Offcanvas.Body className="bid-request-modal p-0">
                <BidList id={bid} setActiveTab={setActiveTab} setShowBids={setBidShow} />
              </Offcanvas.Body>
            </Offcanvas>
            <ViewModal show={viewFile} handleClose={handleClose} folderId={folderId} />
          </div >
        ) : (
          <>
            <div className="outer-white mission-div">
              <div className="mt-2 ">
                <div className="disaster-card mx-auto text-center">
                  <div className="alert-distaster mx-auto">
                    <img src={star} alt="" />
                  </div >
                  <h2>No Items Available!</h2>
                </div >
              </div >
            </div >
          </>
        )}
    </>
  );
};

export default ActivecadsClient;
